class StorageService {
  set(id, data) {
    data = JSON.stringify(data);
    window.localStorage.setItem(id, data);
  }
  get(id) {
    var data = window.localStorage.getItem(id);
    if (data == null || data === "") return null;
    if (data === "true") {
      return true;
    } else if (data === "false") {
      return false;
    }
    try {
      return JSON.parse(data);
    } catch (e) {
      return data;
    }
  }
}
export default new StorageService();
